export default {
  Regular: 1,
  System: 2,
  Chat: 3,
};
